
function SupportedOS() {
    if ($.browser.mobile) {
        var isiPad = /ipad/i.test(navigator.userAgent.toLowerCase());
        var isiPhone = /iphone/i.test(navigator.userAgent.toLowerCase());
        var isAndroid = /android/i.test(navigator.userAgent.toLowerCase());
        if (isiPad || isiPhone || isAndroid)
            return true;
    }

    if (navigator.appVersion.indexOf('Win') != -1)
        return true;
    if (navigator.appVersion.indexOf('Mac') != -1) 
        return true;
    if (navigator.appVersion.indexOf('CrOS') != -1)
        return true;

    return false;
}


function SupportedBrowserOnOS() {
    if ($.browser.mobile && navigator.appVersion.indexOf('Mac') < 0)
        return true;

    var boolResult = false;

    // Windows
    if (navigator.appVersion.indexOf('Win') != -1) {
        // FF
        if (/Firefox[\/\s](\d+\.\d+)/.test(navigator.userAgent))
            boolResult = true;
        // Edge
        else if (/Edge/.test(navigator.userAgent))
            boolResult = true;
        //Chrome
        else if ($.browser.chrome)
            boolResult = true;
    }
    // Mac OS X
    else if (navigator.appVersion.indexOf('Mac') != -1) {
        // Safari
        if ($.browser.safari && $.browser.versionNumber > 9)
            boolResult = true;
        // FF
        if (/Firefox[\/\s](\d+\.\d+)/.test(navigator.userAgent))
            boolResult = true;
    }
    else if (navigator.appVersion.indexOf('CrOS') != -1) {
        if ($.browser.chrome)
            boolResult = true;
    }

    return boolResult;
}


